<div >
  <table class="table is-fullwidth is-hoverable">
    <thead>
      <tr>
        <th>

        </th>
        @for(header of TABLE_HEADERS; track header) {
          <th [ngClass]="{'has-text-centered': header.isCentered}">{{ header.title }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for(item of data; track item) {
        <tr
        [attr.data-index]="item" 
        draggable="true"
        (dragstart)="onDragStart($event, item)" 
        (dragover)="onDragOver($event)" 
        (drop)="onDrop($event, item)"
        class="row-group" 
        >
        <td>
          <fa-icon [icon]="faBars"></fa-icon>
        </td>
        @for(header of TABLE_HEADERS; track header; let i = $index) {
          @if (header.key) {
            @if(header.key === 'name') {
              <td [ngClass]="{'has-text-centered': header.isCentered}">{{ item.product.description }}</td>
            }
            @else if(header.key === 'grad') {
              <td [ngClass]="{'has-text-centered': header.isCentered}">{{ item.product.id }}</td>

            }
            @else if(header.type === FieldType.Date) {
              <td [ngClass]="{'has-text-centered': header.isCentered}">{{ item[header.key] | date: 'dd/MM/yyyy HH:mm':'UTC' }}</td>
            } @else if (header.type === FieldType.Object) {
              <td [ngClass]="{'has-text-centered': header.isCentered}">{{ item[header.key]?.description  || ''}}</td>
            }
            @else {
              
              <td [ngClass]="{'has-text-centered': header.isCentered}">{{ item[header.key] }}</td>
            }
          }@else {
            <td></td>
          }
        }
    </tr>
    @if (item.envasadora_orders?.length > 0) {
      @for (subOrder of item.envasadora_orders; track subOrder) {
        <tr class="row-group sub-row" [ngStyle]="{'cursor':'default'}">
          <td [ngStyle]="{'cursor':'default'}">

          </td>
          @for (header of TABLE_HEADERS; track header) {
            @if (header.key) {
              @if(header.type === FieldType.Date) {
                <td [ngStyle]="{'cursor':'default'}" [ngClass]="{'has-text-centered': header.isCentered}">{{ subOrder[header.key] | date: 'dd/MM/yyyy HH:mm':'UTC' }}</td>
              } @else if (header.type === FieldType.Object) {
                <td [ngStyle]="{'cursor':'default'}" [ngClass]="{'has-text-centered': header.isCentered}">{{ subOrder[header.key]?.description || '' }}</td>
              }
              
              @else {
                <td  [ngStyle]="{'cursor':'default'}" [ngClass]="{'has-text-centered': header.isCentered}">{{ subOrder[header.key] }}</td>
              }
            }
            @else {
              <td></td>
            }
          }
        </tr>
      }
    }
      }
    </tbody>
  </table>
  
  </div>
  